<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        hide-header
        extraLarge
        ref="RkmModal"
    >
        <Form
            :model="model"
            @saved="saved"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        model: {
            faaId: null,
            nomePaciente: null,
            setor: null,
            motivoCancelamentoEvasao: null,
        },
    }),
    methods: {
        open(item) {
            this.model.faaId = item.faaId
            this.model.nomePaciente = item.nome
            this.model.setor = item.setor
            this.model.motivoCancelamentoEvasao = null
            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved(item) {
            this.$emit('saved', item)
            this.handleExit()
        },
    },
}
</script>